import React from 'react';
import AuthPageSkeleton from '../components/AuthPageSkeleton';
import ResetPasswordForm from './ResetPasswordForm';

/**
 * @component for reset password page
 */
const ResetPassword: React.FC = () => {
  return (
    <AuthPageSkeleton>
      <ResetPasswordForm />
    </AuthPageSkeleton>
  );
};

export default ResetPassword;
